import React, { useState } from "react";
import {
  TextArea,
  MyMessage,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { useStaticContext } from "../../context/StaticContext";
import { getOneTerms } from "../../lib/sysNavigation/SysNavigation";
import { FiFileText } from "react-icons/fi";

const Edit = () => {
  const { updateTerms } = useStaticContext();
  const terms: any = getOneTerms();

  const [error, setError] = useState<any>(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<any>(false);

  const terms_id = terms?.terms_id;
  const [description, setDescription] = useState<any>(terms?.description);

  const termsRoutes = "/terms";

  const responses = (error: any, message: any) => {
    setError(error);
    setSuccess(!error);
    setLoading(false);
    setErrorMessage(message);
  };

  const updateOneTermsHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const { status, message } = await updateTerms({
      id: terms_id,
      data: { description },
    });
    if (status === 200) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null);
    setSuccess(null);
  };

  return (
    <AddPageShell
      backRoute={termsRoutes}
      eyebrow="Settings • Terms"
      title="Edit Terms of Service"
      subtitle="Keep the language clear and concise."
      icon={<FiFileText className="h-5 w-5" />}
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneTermsHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection title="Content" hint="Markdown is supported.">
        <TextArea
          props={{
            id: "description",
            title: "",
            type: "text",
            value: description ? description : "",
            rows: 10,
            onChange: (e: any) => {
              setDescription(e.target.value);
              clearMessages();
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
